"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var sis_select_option_component_1 = require("./sis-select-option/sis-select-option.component");
var sis_select_group_option_component_1 = require("./sis-select-group-option/sis-select-group-option.component");
var sis_virtual_scroll_viewport_component_1 = require("../virtual-scroller/virtual-scroll-viewport/sis-virtual-scroll-viewport.component");
var selection_change_1 = require("./event/selection-change");
var data_model_1 = require("./models/data.model");
var operators_1 = require("rxjs/operators");
var Subject_1 = require("rxjs/Subject");
require("./sis-select.component.css");
var SisSelectComponent = /** @class */ (function () {
    function SisSelectComponent() {
        /**
         * Unique field name of values, if they have object type.
         */
        this.uniqueFieldName = 'id';
        /**
         * Indicates whether select should open automatically
         */
        this.autoOpen = false;
        /**
         * Holds the options based on the inner components
         */
        this.allItems = [];
        /**
         * Holds the current/actual options which are shown in the view, it can be modified (e.g. filtered)
         */
        this.filteredItems = [];
        /**
         * Triggers on selection change
         * @type {EventEmitter}
         */
        this.change = new core_1.EventEmitter();
        /**
         * Triggers when selection panel get closed
         * @type {EventEmitter}
         */
        this.onClose = new core_1.EventEmitter();
        /**
         * Triggers when selection panel opens
         * @type {EventEmitter}
         */
        this.onOpen = new core_1.EventEmitter();
        this._unsubscribe$ = new Subject_1.Subject();
        this.selectedIndex = 0;
        /**
         * Holds the height of each select option height in pixels
         */
        this.itemHeight = 39;
        this._defaultItemsOnViewport = 9;
        /**
         * Holds the maximum amount of select options that are seen in DOM
         */
        this.itemsOnViewport = this._defaultItemsOnViewport;
    }
    SisSelectComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.isSelectItemsExist() || this.isGroupItemsExist()) {
            this.initiateItems();
            this.setSelectedIndex(this.value);
        }
        this.selectItems.changes.pipe(operators_1.takeUntil(this._unsubscribe$)).subscribe(function (r) {
            _this.initiateItems();
        });
        this.groupItems.changes.pipe(operators_1.takeUntil(this._unsubscribe$)).subscribe(function (r) {
            _this.initiateItems();
        });
        this.itemsOnViewport = Math.min(this._defaultItemsOnViewport, this.filteredItems.length);
        if (this.autoOpen) {
            this.open();
        }
        this._selectionChangeSubscription = this.select.selectionChange.asObservable().subscribe(function (change) {
            _this.setSelectedIndex(change.value);
            _this.select.value = change.value;
            _this.change.emit(new selection_change_1.SelectionChange(change.value));
        });
        this._openCloseChangeSubscription = this.select.openedChange.asObservable().subscribe(function (opened) {
            if (opened) {
                _this.onOpen.emit(true);
            }
            else {
                _this.onClose.emit(true);
            }
        });
    };
    SisSelectComponent.prototype.ngOnDestroy = function () {
        if (this._selectionChangeSubscription) {
            this._selectionChangeSubscription.unsubscribe();
        }
        if (this._openCloseChangeSubscription) {
            this._openCloseChangeSubscription.unsubscribe();
        }
        this._unsubscribe$.next();
        this._unsubscribe$.complete();
    };
    SisSelectComponent.prototype.setSelectedIndex = function (value) {
        if (typeof value === 'object' && value != null) {
            var id_1 = this.uniqueFieldName;
            this.selectedIndex = this.allItems.findIndex(function (item) { return item.value[id_1] === value[id_1]; });
        }
        else {
            this.selectedIndex = this.allItems.findIndex(function (item) { return item.value === value; });
        }
    };
    Object.defineProperty(SisSelectComponent.prototype, "scrollContainer", {
        /**
         * Holds the element which scroll event must be listened
         */
        get: function () {
            return (this.select.panel && this.select.panel.nativeElement) || this.selectRef.nativeElement;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisSelectComponent.prototype, "virtualForItems", {
        get: function () {
            return !this.isPanelOpen() ? this.filteredItems.slice(this.selectedIndex) : this.filteredItems;
        },
        enumerable: true,
        configurable: true
    });
    SisSelectComponent.prototype.open = function () {
        var self = this;
        setTimeout(function () {
            self.select.open();
            setTimeout(function () {
                if (self.searchable && self.autofocus) {
                    self.searchInput.focus();
                }
            });
        }, 0);
    };
    SisSelectComponent.prototype.close = function () {
        this.select.close();
    };
    SisSelectComponent.prototype.isPanelOpen = function () {
        return this.select.panelOpen;
    };
    SisSelectComponent.prototype.filter = function () {
        if (this.searchTerm) {
            this.viewPort.scrollToIndex(0);
            var result = [];
            var searchTermToLower = this.searchTerm.toLowerCase();
            var currentGroup_1;
            for (var _i = 0, _a = this.allItems; _i < _a.length; _i++) {
                var item = _a[_i];
                if (item.isGroup) {
                    currentGroup_1 = item;
                }
                if (!item.isGroup && item.label.toLowerCase().indexOf(searchTermToLower) > -1) {
                    var prevItem = result[result.length - 1];
                    if (prevItem && prevItem.groupIndex !== item.groupIndex) {
                        result.push(this.allItems[item.groupIndex]);
                    }
                    else if (currentGroup_1 && result.findIndex(function (item) { return item.label === currentGroup_1.label; }) === -1) {
                        result.push(currentGroup_1);
                    }
                    result.push(item);
                }
            }
            this.filteredItems = result;
        }
        else {
            this.reloadItems();
        }
    };
    SisSelectComponent.prototype.onSelectOpen = function (event) {
        this.searchTerm = '';
        this.reloadItems();
        if (this.autofocus) {
            this.searchInput.focus();
        }
        var scrollTo = this.isPanelOpen() ? this.selectedIndex : 0;
        this.viewPort.scrollToIndex(scrollTo);
        this.viewPort.checkViewportSize();
    };
    SisSelectComponent.prototype.reloadItems = function () {
        this.filteredItems = this.allItems;
    };
    /**
     * Fills items by using provided selectItems and groupItems
     */
    SisSelectComponent.prototype.initiateItems = function () {
        this.allItems = [];
        for (var _i = 0, _a = this.selectItems.toArray(); _i < _a.length; _i++) {
            var option = _a[_i];
            this.allItems.push(new data_model_1.DataModel(false, undefined, option.label, option.className, option.value));
        }
        for (var _b = 0, _c = this.groupItems.toArray(); _b < _c.length; _b++) {
            var group = _c[_b];
            var groupIndex = this.allItems.length;
            if (!group.isEmpty || group.displayEmpty) {
                this.allItems.push(new data_model_1.DataModel(true, undefined, group.label, group.className));
            }
            for (var _d = 0, _e = group.options; _d < _e.length; _d++) {
                var option = _e[_d];
                this.allItems.push(new data_model_1.DataModel(false, groupIndex, option.label, option.className, option.value));
            }
        }
        this.filteredItems = this.allItems;
    };
    SisSelectComponent.prototype.isSelectItemsExist = function () {
        return this.selectItems && this.selectItems.length > 0;
    };
    SisSelectComponent.prototype.isGroupItemsExist = function () {
        return this.groupItems && this.groupItems.length > 0;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisSelectComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisSelectComponent.prototype, "value", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisSelectComponent.prototype, "uniqueFieldName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisSelectComponent.prototype, "placeholder", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], SisSelectComponent.prototype, "searchable", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], SisSelectComponent.prototype, "autofocus", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], SisSelectComponent.prototype, "autoOpen", void 0);
    __decorate([
        core_1.ViewChild(material_1.MatSelect),
        __metadata("design:type", material_1.MatSelect)
    ], SisSelectComponent.prototype, "select", void 0);
    __decorate([
        core_1.ViewChild(material_1.MatSelect, { read: core_1.ElementRef }),
        __metadata("design:type", core_1.ElementRef)
    ], SisSelectComponent.prototype, "selectRef", void 0);
    __decorate([
        core_1.ViewChild(sis_virtual_scroll_viewport_component_1.SisVirtualScrollViewportComponent),
        __metadata("design:type", sis_virtual_scroll_viewport_component_1.SisVirtualScrollViewportComponent)
    ], SisSelectComponent.prototype, "viewPort", void 0);
    __decorate([
        core_1.ViewChild(material_1.MatInput),
        __metadata("design:type", material_1.MatInput)
    ], SisSelectComponent.prototype, "searchInput", void 0);
    __decorate([
        core_1.ContentChildren(sis_select_option_component_1.SisSelectOptionComponent),
        __metadata("design:type", core_1.QueryList)
    ], SisSelectComponent.prototype, "selectItems", void 0);
    __decorate([
        core_1.ContentChildren(sis_select_group_option_component_1.SisSelectGroupOptionComponent),
        __metadata("design:type", core_1.QueryList)
    ], SisSelectComponent.prototype, "groupItems", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], SisSelectComponent.prototype, "change", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], SisSelectComponent.prototype, "onClose", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], SisSelectComponent.prototype, "onOpen", void 0);
    SisSelectComponent = __decorate([
        core_1.Component({
            
            selector: 'sis-select',
            template: require('./sis-select.component.html'),
            encapsulation: core_1.ViewEncapsulation.None,
            changeDetection: core_1.ChangeDetectionStrategy.OnPush
        }),
        __metadata("design:paramtypes", [])
    ], SisSelectComponent);
    return SisSelectComponent;
}());
exports.SisSelectComponent = SisSelectComponent;
//# sourceMappingURL=sis-select.component.js.map